import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import Select from 'react-select'; //13/3/2024
export default function MapPermission() {
  const isAuth = useAuth();
  const navigate = useNavigate();
  if (isAuth === false) {
    navigate("/admin/")
  }
  const [permissions, setPermissions] = useState([]);
  const [message, setMessage] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null); // State to hold selected permission
  const [isassignroleperm, setAssignRolePerm] = useState(false);//13/3/2024
  const { http } = Api();


  //role validation -13/3/2024
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get('/Admin/get-all-user-permissions', {params: { user_id: id }});      
      //console.log(response);
      const permissions = response.data;   
      permissions.forEach(permission => {      
        if (permission.name ==="assign-permission-to-role") { 
            setAssignRolePerm(true);
          }
        });
         
         
      } catch (error) {      
        setAssignRolePerm(false);
       
      }
    };
    access();
  }, []);

  

  //load permissions to select box
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { http } = Api();
        //console.log("b4resp");
        const response = await http.get(`/Admin/get-permissions`, {
          params: {
            limit: '1000',
          }
        });
        //console.log("afterresp"+response);
        setPermissions(response.data.data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();

  }, []);

  let { rolename } = useParams();
  let decodedName;
  try {
    decodedName = decodeURIComponent(atob(rolename));
    //console.log(decodedName + "decodedName");
  } catch (error) {
    console.error("Error decoding Base64 string:", error);
    // Handle the error gracefully, such as showing a user-friendly message
  }

  const cancelForm = () => {
    navigate("/admin/roles");
  };

  const validateForm = () => {
    if (!selectedPermission || !selectedPermission.value) {
        setMessage('Please select Permission');
        return false;
    }
    return true;
};

  const encodeID = rolename => {
    const encodedName = encodeURIComponent(rolename);
    //console.log("Encoded Role Name:", encodedName);
    //console.log("btoa(encodedName):", btoa(encodedName));
    return btoa(encodedName);
  };

  const saveForm = (event) => {
    event.preventDefault();

    if (validateForm()) {
      //const endpoint = `/Admin/${decodedid}/give-permission/${permissionid}`;
      const endpoint = `/Admin/assign-permission-to-role/${selectedPermission.value}/${decodedName}`


      http.put(endpoint)
        .then(response => {

          //console.log(response.data);

          if (response.data.status_code === "MSG11") {


            sessionStorage.setItem("message", "Permission assigned to role successfully");
            navigate(`/admin/rolebypermission/${encodeID(decodedName)}`);


          }
        })
        .catch(error => {
          console.error(error);
          setMessage("Something Went Wrong");


        });
    }
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  return (
    <>
    
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Map New Permission</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {message && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                      </div>
                    )}
                    <div className="card-body pdg" style={{minHeight:'500px'}}>
                      <div className="table-responsive">

                      {isassignroleperm && (
                        <form className="form theme-form">
                          <div className="card-body custom-input" style={{ overflow: 'visible' }}>

                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-4">Role</label>
                                  <div className="col-sm-6">
                                    <input className="form-control input-air-primary" type="text" readOnly id="rolename" name="rolename" value={decodedName} maxLength={3} />
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-4">Select Permission</label>
                                  <div className="col-sm-6">
                                    {/*<select className="form-control" id="permissionid" name="permissionid" onChange={(e) => setPermissionid(e.target.value)}  required>
                                        <option value="">Select Permission</option>
                                        {permissions.map(permission => (

                                            <option value={permission.name}>{permission.name}</option>
                                        ))}
                                        </select>*/}

                                    <Select
                                      className="form-control"
                                      options={permissions.map(permission => ({ value: permission.name, label: permission.name }))}
                                      onChange={(selectedOption) => setSelectedPermission(selectedOption)}
                                      value={selectedPermission}
                                      placeholder="Select Permission"
                                      isSearchable
                                      menuPortalTarget={document.body}
                                      styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            fontSize: '14px', // Set font size to 14px
                                           
                                            
                                        }),
                                        menuList: (provided) => ({
                                          ...provided,
                                          maxHeight: '200px', 
                                         
                                          
                                      }),
                                      ...customStyles
                                    }}
                                      
                                        />
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 txt-aln">
                            <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                            <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                          </div>

                        </form>)}



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
